<template>
  <div class="detRight">
    <div class="teacher">
      <div class="img"><img :src="lecturer.avatar" width="80" height="80" alt=""></div>
      <div class="name">{{lecturer.name}}</div>
      <div class="dec">{{lecturer.signature}}</div>
      <div class="p">{{lecturer.profile}}</div>
    </div>
    <div class="recommended">
      <div class="tit">推荐课程</div>
      <ul>
        <li @click="pushcourseClick(item.id)" v-for="(item, index) in pushcourse" :key="index">
          <div class="img fl"><img :src="item.cover" width="135" height="95" alt=""></div>
          <div class="Txt fr">
            <h5 class="line-clamp-1">{{item.title}}</h5>
            <div class="num">
              <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
              <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lecturer: {
        type: Object
      },
      pushcourse: {
        type: Array
      }
    },
    methods: {
      pushcourseClick (id) {
        this.$parent.$parent.id = id
        this.$parent.$parent.getData()
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .detRight {
    width: 400px;
    margin-top: 20px;

    .teacher {
      width: 400px;
      box-shadow: 0px 0px 35px #f8f8f8;
      border-radius: 20px;
      position: relative;
      padding-bottom: 40px;

      .img {
        width: 80px;
        height: 80px;
        position: absolute;
        left: 160px;
        top: -40px;
        background-color: #fff;
        border-radius: 50%;
        overflow: hidden;
      }

      .name {
        font-size: 26px;
        text-align: center;
        padding-top: 60px;
      }

      .dec {
        color: #6f6f6f;
        text-align: center;
        margin: 20px auto 0;
        padding: 0 20px;
        line-height: 25px;
      }

      .p {
        line-height: 25px;
        padding: 0 20px;
        margin: 20px auto 0;
      }
    }

    .recommended {
      .tit {
        font-size: 18px;
        color: #5c5c5c;
        font-weight: bold;
        margin: 40px auto 0;
      }
    }

    ul {
      li {
        height: 95px;
        width: 400px;
        margin: 20px 0 0 0;
        cursor: pointer;

        .img {
          height: 95px;
          width: 135px;
          border-radius: 5px;
          overflow: hidden;
        }

        .Txt {
          width: 240px;
          height: 95px;
          border-bottom: 1px solid #ebebeb;

          h5 {
            font-size: 16px;
            margin-top: 20px;
          }

          .num {
            height: 20px;
            width: 100%;
            font-size: 12px;
            color: #8f8f8f;
            margin-top: 10px;

            img {
              display: block;
              float: left;
            }

            .people {
              line-height: 20px;
              margin-right: 20px;

              img {
                margin: 3px 5px 0 0;
              }
            }

            .comment {
              line-height: 20px;

              img {
                margin: 5px 5px 0 0;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/detRight/detRight.vue